import { InjectionToken } from '@angular/core';
import { ClientOrigin } from '@vendasta/sales-opportunities';

export const CLIENT_ORIGIN_TOKEN = new InjectionToken<ClientOrigin>('client origin token');
